import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

export const report_category_table_data_api = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/ReportingCategoryList`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'report_category_table_data_api');
    }
};

export const report_category_delete = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/delete_cuzcategory`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'report_category_delete');
    }
};

// ------------------- Completed Topics Report API -----------------------

export const user_session_data = async (data) => {
    try {
        const response = await axiosInstance.get(`/api/user_session_data_completerpt?userid=${data}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'user_session_data');
    }
};

export const report_data = async ({userid, customerid}) => {
    try {
        const response = await axiosInstance.get(`/api/report_data_program?userid=${userid}&customerid=${customerid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'report_data');
    }
};

export const report_group_location_api = async ({customerid}) => {
    try {
        const response = await axiosInstance.get(`/api/report_group_desc?customerid=${customerid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'report_group_location_api');
    }
};

export const custgroup_location_api = async ({customerid, Custgroupid, Groupid}) => {
    try {
        const response = await axiosInstance.get(`/api/custgroup_location?customerid=${customerid}&Custgroupid=${Custgroupid}&Groupid=${Groupid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'custgroup_location_api');
    }
};

// ------------------ Topic History Comparison API -------------------------

export const compare_user_session_data = async (data) => {
    try {
        const response = await axiosInstance.get(`/api/user_session_data?userid=${data}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'compare_user_session_data');
    }
};

export const runreporta = async ({userid, customerid}) => {
    try {
        const response = await axiosInstance.get(`/api/runreporta?userid=${userid}&customerid=${customerid}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'runreporta');
    }
};

export const comparerpt_run_report_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/comparerpt_run_report`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'comparerpt_run_report_api');
    }
};

export const runreporta_api = async (data) => {
    try {
        console.log(data);
        const response = await axiosInstance.post(`/api/runreporta`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'runreporta_api');
    }
};

export const comparerpt_drilldown_api = async (data) => {
    try {
        const response = await axiosInstance.get(`/api/comparerpt_drilldown?topicid=${data.topicid}&customerid=${data.customerid}&locationid=${data.locationid}&latestperiod=${data.latestperiod}&periodcode=${data.periodcode}`);
        return response;
    } catch (error) {
        throw handleApiError(error, 'comparerpt_drilldown_api');
    }
};
